import EpisodeTitle from './EpisodeTitle';

export default EpisodeTitle;
